import {stringify} from "qs";

import {FrontendRequest} from "services-comun/modules/net/request-frontend";

import {IPartidoResumen, IPartidoWeb} from "./interfaces/partidos";
import dominio from "../../portal/ed";

export class CompeticionesWebFrontendRequest extends FrontendRequest {
    /* STATIC */
    private static SERVICIO: string = dominio.get(dominio.SERVICES);

    public static async partido(id: number): Promise<IPartidoWeb> {
        const params = stringify({
            id
        });
        return await this.get<IPartidoResumen[]>(`${this.SERVICIO}/web/competiciones/partido/?${params}`).then((x: any) => x.data);

    }

    /* INSTANCE */
}
